<template>
  <Form ref="formValidate" :model="formValidate" :label-width="80">
    <FormItem :label="type == 1 ? '备注' : '拒绝原因'" prop="remark">
      <Input type="textarea" v-model="formValidate.remark" />
    </FormItem>
  </Form>
</template>
<script>
import { Form, FormItem, Input, InputNumber } from "view-design";
export default {
  props: {
    obj: Object,
    type: Object,
  },
  data() {
    return {
      formValidate: {
        remark: "",
        type: this.type,
      },
    };
  },
  methods: {},
};
</script>
